<template>
  <div class="personalInformation">
    <div class="title">
      <span>填写资料信息</span>
      <span class="tip">温馨提示：请输入正确的个人信息</span>
    </div>
    <div class="content">
      <!--头部标题-->
      <div class="headerTitle">
        <img src="@/assets/style/contactInfo-icon.png" alt="" />
        <span>填写个人信息</span>
      </div>
      <!--职业字段-->
      <professionField label="职业" v-model="professionField" />
      <!--工作单位字段-->
      <addressField label="工作单位" v-model="addressField" />
      <!--年收入/万-->
      <AnnualIncomeField label="年收入/万" v-model="annualIncomeField" />
      <!--qq号-->
      <qqField label="qq号" v-model="qqField" />
      <!--发薪时间-->
      <SalaryPaymentField label="发薪日期" v-model="salaryPaymentField" />
      <!--婚姻状态-->
      <MaritalStatusField label="婚姻状态" v-model="maritalStatusField" />
    </div>
    <!--确定按钮-->
    <div class="confirmButton" @click="handleSubmitClick">
      <div :class="{ disabled: disabled }" class="confirmText">提交资料</div>
    </div>
    <div class="personalInformationblock"></div>
    <Popup
      ref="popup"
      cancelText="返回首页"
      @confirm="handleConfirm"
      @cancel="handleCancel"
      :message="`${blackListAd?.popContent || '资质不匹配'}`"
      :confirmText="blackListAd?.popBtnName || '去查看'"
      :title="blackListAd?.popTitle || '资质不匹配'"
    />
  </div>
</template>

<script>
import professionField from "@/components/idCardBinding/professionField.vue";
import addressField from "@/components/idCardBinding/addressField.vue";
import AnnualIncomeField from "@/components/idCardBinding/AnnualIncomeField.vue";
import SalaryPaymentField from "@/components/idCardBinding/SalaryPaymentField.vue";
import MaritalStatusField from "@/components/idCardBinding/MaritalStatusField.vue";
import qqField from "@/components/idCardBinding/qqField.vue";
import { updateContactInfo } from "@/api/index.js";
import Popup from "@/components/Popup/index.vue";
import { getLocalStorageData } from "@/common/index.js";

export default {
  name: "PersonalInformation",
  components: {
    professionField,
    addressField,
    AnnualIncomeField,
    SalaryPaymentField,
    MaritalStatusField,
    Popup,
    qqField,
  },
  data() {
    return {
      professionField: "",
      addressField: "",
      annualIncomeField: "",
      salaryPaymentField: "",
      maritalStatusField: "",
      qqField: "",
    };
  },
  activated(){
    this.$nextTick(() => {
      const userAllInfo = getLocalStorageData('UserAllInfo')
      if(userAllInfo.authentication){
        this.professionField= userAllInfo.authentication.career,
        this.addressField= userAllInfo.authentication.workCompany,
        this.annualIncomeField= userAllInfo.authentication.yearIncome,
        this.salaryPaymentField= userAllInfo.authentication.salaryTime,
        this.maritalStatusField= userAllInfo.authentication.married,
        this.qqField= userAllInfo.authentication.qq
      }
    })
  },
  methods: {
    handleToOtherProduct() {
      if(this.blackListAd.urlType == 2) return;
      //去其他产品
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.blackListAd.url,
          title: this.blackListAd.name,
        });
      } else {
        window.open(this.blackListAd.url);
      }
    },
    handleConfirm() {
      if(this.blackListAd.urlType == 2) return;
      //去其他产品
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.blackListAd.url,
          title: this.blackListAd.name,
        });
      } else {
        window.open(this.blackListAd.url);
      }
    },
    handleCancel() {
      this.$router.push({
        name: "Home",
      });
    },
    handleSubmitClick() {
      if(this.disabled) return;
      const contactInfo = {
        career: this.professionField,
        workCompany: this.addressField,
        yearIncome: this.annualIncomeField,
        salaryTime: this.salaryPaymentField,
        married: this.maritalStatusField,
        qq: this.qqField,
      };
      updateContactInfo(contactInfo).then((res) => {
        if (res.code == 2000) {
          this.$store.commit("setRouterFlag", "2");
          this.$router.replace({
            name: "loan",
          });
        } else {
          if (res.code == 10016) {
            this.$emit("submitClick");
          } else if (res.code == 10010 || res.code == 10009 || res.code == 10004) {
            this.$refs.popup.showPopup();
          }else {
            this.$toast(res.message);
          }
        }
      });
    },
  },
  computed: {
    disabled() {
      return (
        this.professionField == "" ||
        this.addressField == "" ||
        this.annualIncomeField == "" ||
        this.salaryPaymentField == "" ||
        this.maritalStatusField == "" ||
        this.qqField == ""
      );
    },
    blackListAd() {
      return this.$store.state.blackListAd;
    },
  },
};
</script>

<style scoped lang="scss">
.personalInformation {
  padding-top: 16px;
}
.title {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: #333333;
  .tip {
    font-size: 12px;
    color: #f9ae3d;
  }
}
.content {
  margin-top: 16px;
  padding: 10px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .headerTitle {
    display: flex;
    align-items: center;
    img {
      width: 8px;
      height: 8px;
      margin-right: 4px;
    }
  }
}
.confirmButton {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 94px;
  line-height: 94px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px -2px 19px 0px rgba(0, 0, 0, 0.15),
    0px 1px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  .confirmText { 
    background: #1d70f7;
    border-radius: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    height: 51px;
    margin: 0px 16px;
    width: 100%;
  }
  .disabled {
    background: #8eb7fb;
  }
}
.personalInformationblock{
  height: 100px;
  width: 100%;
  background: #ffffff;
}
</style>
